<template>
	<div class="navbar">
		<div class="logo">
			<logo :collapse="isCollapse"></logo>
		</div>

		<div class="right-menu">
			<template v-if="device !== 'mobile'">
				<screenfull id="screenfull" class="right-menu-item hover-effect" />
			</template>

			<el-dropdown
				class="avatar-container right-menu-item hover-effect"
				trigger="hover"
			>
				<div class="avatar-wrapper right-menu-item">
					<img :src="require('@/assets/logo/avatar.jpg')" class="user-avatar" />
				</div>
				<el-dropdown-menu slot="dropdown" style="font-size: 12px">
					<div class="dropdown-header">
						<div v-if="userInfo.username"
							class="dropdown-header-row">
							<i class="el-icon-user dropdown-header-icon"></i>
							<span>{{userInfo.username}}</span>
						</div>
					</div>
					<el-dropdown-item
						v-if="device !== 'mobile'"
						icon="el-icon-setting"
						@click.native="hexiao"
					>
						更换Logo
					</el-dropdown-item>
					<el-dropdown-item icon="el-icon-lock" @click.native="editpwd">
						{{ $t("navbar.editpwd") }}
					</el-dropdown-item>
					<el-dropdown-item v-if="changeRoleList.length" icon="el-icon-sort" @click.native="roleDialogVisible = true">
						切换角色
					</el-dropdown-item>
					<el-dropdown-item
						icon="el-icon-switch-button"
						style="color: #f56c6c"
						divided
						@click.native="logout"
					>
						{{ $t("navbar.logOut") }}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>

			<el-dialog
				title="修改密码"
				v-if="editdialog.dialogFormVisible"
				:visible.sync="editdialog.dialogFormVisible"
				:show-close="true"
				:close-on-click-modal="false"
				width="40%"
			>
				<el-form
					:model="editdialog.date"
					:rules="rules"
					ref="resetPwdForm"
					label-width="80px"
				>
					<el-form-item label="旧密码：" prop="oldPassword">
						<el-input
							type="password"
							show-password
							v-model="editdialog.date.oldPassword"
							auto-complete="old-password"
						></el-input>
					</el-form-item>
					<el-form-item label="新密码：" prop="newPassword">
						<el-input
							type="password"
							show-password
							v-model="editdialog.date.newPassword"
							auto-complete="new-password"
						></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="editdialog.dialogFormVisible = false">{{
						$t("table.cancel")
					}}</el-button>
					<el-button type="primary" @click.stop="toAmend"
						>确认修改</el-button
					>
				</div>
			</el-dialog>
			<el-dialog
				:title="editdialog1.title"
				:visible.sync="editdialog1.dialogFormVisible"
				:show-close="true"
				width="1000px"
				top="10px"
				:close-on-click-modal="false"
			>
				<!-- 修改 -->
				<upload-list
					v-if="editdialog1.dialogFormVisible"
					type="radio"
					:url="editdialog1.date.logoUrl"
					:limit="1"
					@saveUrl="saveUrl"
				></upload-list>
				<div slot="footer" class="dialog-footer">
					<el-button @click="hexiao()">{{ $t("table.cancel") }} </el-button>
					<el-button type="primary" @click="submitForm">{{
						$t("table.confirm")
					}}</el-button>
				</div>
			</el-dialog>
			<el-dialog
				title="修改密码"
				:visible.sync="pwdTipDialogVisible"
				:show-close="true"
				:close-on-click-modal="false"
				width="500px"
			>
				<h3 style="text-align:center;padding:40px 0;font-size:18px!important;color:#666;">为保障系统安全，请修改您的初始密码!</h3>
				<div slot="footer" style="text-align: center;">
					<el-button type="primary" @click.stop="pwdTipDialogVisible=false;editpwd()">前往修改</el-button>
				</div>
			</el-dialog>
			<el-dialog
				title="切换角色"
				v-if="roleDialogVisible"
				:visible.sync="roleDialogVisible"
				:show-close="true"
				:close-on-click-modal="false"
				width="500px"
			>
				<div class="role-change-body">
					<el-button
						v-for="item in changeRoleList"
						:key="item.roleCode"
						:disabled="item.roleCode == userInfo.roleCode"
						type="primary"
						class="role-change-body-btn"
						@click.stop="changeDefaultRole(item.roleCode)">{{ item.roleName }}</el-button>
				</div>
				<!-- <div slot="footer" class="dialog-footer">
					<el-button @click="editdialog.dialogFormVisible = false">{{
						$t("table.cancel")
					}}</el-button>
					<el-button type="primary" @click.stop="toAmend"
						>确认修改</el-button
					>
				</div> -->
			</el-dialog>
		</div>
	</div>
</template>

<script>
import Logo from './Logo'
import { mapGetters, mapState } from 'vuex'
// import Breadcrumb from '@/components/Breadcrumb'
// import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
// import SizeSelect from "@/components/SizeSelect";
// import LangSelect from "@/components/LangSelect";
// import Search from "@/components/HeaderSearch";

import uploadList from '@/components/UploadImageList'
import { changeDefaultRole } from '@/api/baseotherset'

const roleNameByCode = {
	ROLE_MERCHANT: '商户/仓库类角色',
	ROLE_ORG: '组织类角色'
}

export default {
	components: {
		// Breadcrumb,
		// Hamburger,
		Screenfull,
		// Search,
		uploadList,
		Logo
	},
	data () {
		return {
			pwdTipDialogVisible: false,
			imgPath: '',
			editdialog: {
				dialogFormVisible: false,
				dialogStatus: '',
				title: '详细信息',
				date: {}
			},
			editdialog1: {
				dialogFormVisible: false,
				dialogStatus: '',
				title: 'logo更换',
				date: { logoUrl: '' }
			},
			// resetForm: {
			//  //传给后台所需要的参数
			//  oldPassword: "",
			//  newPassword: "",
			// },
			rules: {
				oldPassword: [
					{ required: true, message: '请输入旧密码', trigger: ['blur', 'change'] }
				],
				newPassword: [
					{ required: true, message: '请输入新密码', trigger: ['blur', 'change'] },
					{ min: 8, message: '密码不少于8位', trigger: ['blur', 'change'] },
					{
						validator: (rule, value, cb) => {
							if (value.includes(this.userInfo.username)) {
								return cb(new Error('密码禁止包含用户名！'))
							}
							if (!/[\.\_\~\!\@\#\$\^\&\*]/.test(value) || !/[0-9]/.test(value) || !/[a-z]/.test(value) || !/[A-Z]/.test(value)) {
								return cb(new Error('密码必须包含大小写字母、数字、特殊字符！'))
							}
							cb()
						},
						trigger: ['blur', 'change']
					}
				]
			},
			listQuery: {},
			roleDialogVisible: false
		}
	},
	created () {
		// alert(987)
	},
	computed: {
		...mapGetters(['permission_routes', 'sidebar', 'avatar', 'device', 'userInfo']),
		...mapState({
			// loginLogoUrl: (state) => state.user.loginLogoUrl,
			logoUrl: (state) => state.user.logoUrl
		}),
		isCollapse () {
			return !this.sidebar.opened
		},
		screenData () {
			console.log(this.permission_routes, 55555555555)
			return this.permission_routes.find(({ path }) => path === '/dataHunter_user')
		},
		changeRoleList () {
			const { roles } = this.userInfo
			return roles.filter(item => !item.startsWith('ROLE_ADMIN')).map(item => {
				const text = roleNameByCode[item.split('&&')[0]]
				return {
					roleCode: item,
					roleName: text || '未知角色'
				}
			})
		}
	},
	methods: {
		changeDefaultRole (roleCode) {
			changeDefaultRole(roleCode).then(res => {
				location.href = '/'
			})
		},
		// logo切换
		hexiao () {
			console.log(this.logoUrl)
			this.editdialog1.dialogFormVisible = !this.editdialog1.dialogFormVisible
			this.editdialog1.date.logoUrl = this.logoUrl
		},
		submitForm () {
			const { logoUrl } = this.editdialog1.date
			if (!logoUrl) {
				this.$message.warning('请选择Logo!')
				return
			}
			if (logoUrl === this.logoUrl) {
				this.$message.warning('请选择不一样的Logo!')
				return
			}
			this.$store
				.dispatch('user/setLogo', logoUrl)
				.then((res) => {
					this.editdialog1.dialogFormVisible = false
					this.$message({
						type: 'success',
						message: 'Logo设置成功!'
					})
				})
				.catch(() => {
					this.$message({
						type: 'danger',
						message: 'Logo设置失败'
					})
				})
		},
		saveUrl (e) {
			this.editdialog1.date.logoUrl = e
		},
		handleDelete () {},
		toggleSideBar () {
			this.$store.dispatch('app/toggleSideBar')
		},

		async logout () {
			await this.$store.dispatch('user/logout')
			this.$router.push(`/login?redirect=${this.$route.fullPath}`)
		},

		editpwd (row, state) {
			if (this.$refs.resetPwdForm) this.$refs.resetPwdForm.resetFields()
			this.editdialog.dialogFormVisible = true
			this.editdialog.date = Object.assign({}, row)
			this.editdialog.dialogStatus = state
		},
		toAmend () {
			this.$refs.resetPwdForm.validate(valid => {
				if (valid) {
					const object = {}
					const keys = Object.keys(this.editdialog.date)
					keys.forEach((v) => {
						object[v] = this.editdialog.date[v]
					})
					object.userId = this.userInfo.userId
					this.$store.dispatch('user/editpwd', object).then(res => {
						this.$message({
							type: 'success',
							message: '密码修改成功,请重新登录！',
							onClose: () => {
								this.editdialog.dialogFormVisible = false
								this.logout()
							}
						})
					})
				}
			})
		}
	},
	watch: {
		userInfo: {
			immediate: true,
			handler (val) {
				if (val.editFlag == 2) this.pwdTipDialogVisible = true
			}
		}
	}
}
</script>

<style lang="scss" scoped>
/deep/ {
	// .el-upload--picture-card {
	//   display: flex;
	//   align-items: center;
	//   justify-content: center;
	// }
	.images .el-form-item__content > div {
		display: flex;
	}
	.el-tag + .el-tag {
		margin: 5px 10px;
	}
}
.navbar {
	height: 50px;
	overflow: hidden;
	// position: relative;
	background: #fff;
	box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
	// z-index: 999999;
	.hamburger-container {
		line-height: 46px;
		height: 100%;
		float: left;
		cursor: pointer;
		transition: background 0.3s;
		-webkit-tap-highlight-color: transparent;

		&:hover {
			background: rgba(0, 0, 0, 0.025);
		}
	}

	.breadcrumb-container {
		float: left;
	}

	.errLog-container {
		display: inline-block;
		vertical-align: top;
	}

	.right-menu {
		float: right;
		height: 100%;

		&:focus {
			outline: none;
		}

		.right-menu-item {
			line-height: 50px;
			display: inline-block;
			// padding: 0 8px;
			width: 50px;
			text-align: center;
			height: 100%;
			font-size: 18px;
			color: #5a5e66;
			vertical-align: text-bottom;

			&.hover-effect {
				cursor: pointer;
				transition: background-color 0.3s;

				&:hover {
					background-color: rgba(0, 0, 0, 0.025);
				}
			}
			&[class*="leniu-icon-"] {
				font-size: 22px;
				color: #111;
				font-weight: bold;
			}
		}

		.avatar-container {
			margin-right: 30px;

			.avatar-wrapper {
				margin-top: 5px;
				position: relative;

				.user-avatar {
					cursor: pointer;
					width: 30px;
					height: 30px;
					border-radius: 4px;
					margin-top: 4px;
				}

				.el-icon-caret-bottom {
					cursor: pointer;
					position: absolute;
					right: -20px;
					top: 25px;
					font-size: 12px;
				}
			}
		}
	}
}
.logo {
	float: left;
	width: 200px;
	z-index: 999;
	box-shadow: 2px 3px 6px rgba(0, 21, 41, 0.35);
}

.navbar .right-menu {

	.leniu-icon-screen2 {
		font-size: 21px !important;
	}
}
.dropdown-header {
	padding: 0 17px;
	&-name {
		font-weight: 600;
		margin: 6px 0;
		font-size: 14px;
	}
	&-row {
		margin: 10px 0;
		color: #9b9b9b;
		font-size: 14px;
	}
	&-icon {
		margin-right: 4px;
	}
}
.role-change-body {
	width: 100%;
	text-align: center;
	padding: 50px 0;
	&-btn {
		width: 112px;
		&:first-child {
			margin-right: 40px!important;
		}
	}
}
</style>
